import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Box,
    Typography,
    Tabs,
    Tab,
    AppBar,
    Paper
} from '@material-ui/core';

import UserPanel from './UserPanel';
import JobPanel from './JobPanel';
import { SavedJobPanel } from './SavedJobPanel';

const useStyles = makeStyles((theme) => ({
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: theme.spacing(2),
    },
    heading: {
        fontSize: '2.4rem',
        fontWeight: 600,
        marginBottom: theme.spacing(3),
        color: theme.palette.primary.main,
    },
    tabHeading: {
        fontSize: '2rem',
        fontWeight: 500,
        marginBottom: theme.spacing(2),
        color: theme.palette.text.primary,
    },
    tabPanel: {
        padding: theme.spacing(3, 0),
    },
    appBar: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        boxShadow: 'none',
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    tab: {
        textTransform: 'none',
        fontSize: '1.6rem',
        fontWeight: 500,
        minWidth: '120px',
        '&.Mui-selected': {
            color: theme.palette.primary.main,
        },
    },
    indicator: {
        backgroundColor: theme.palette.primary.main,
    },
}));

const Dashboard = () => {
    const classes = useStyles();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box className={classes.container}>
            <Typography variant="h1" className={classes.heading}>
                Admin dashboard
            </Typography>

            <AppBar position="static" className={classes.appBar}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    classes={{
                        indicator: classes.indicator,
                    }}
                >
                    <Tab
                        label="Users"
                        className={classes.tab}
                    />
                    <Tab
                        label="Jobs"
                        className={classes.tab}
                    />
                    <Tab
                        label="Saved Jobs"
                        className={classes.tab}
                    />
                </Tabs>
            </AppBar>

            <Box className={classes.tabPanel}>
                {value === 0 && (
                    <Box>
                        <Typography variant="h2" className={classes.tabHeading}>
                            Users
                        </Typography>
                        <UserPanel />
                    </Box>
                )}
                {value === 1 && (
                    <Box>
                        <Typography variant="h2" className={classes.tabHeading}>
                            Jobs
                        </Typography>
                        <JobPanel />
                    </Box>
                )}
                {value === 2 && (
                    <Box>
                        <Typography variant="h2" className={classes.tabHeading}>
                            Saved Jobs
                        </Typography>
                        <SavedJobPanel />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default Dashboard;
